export function getRem(value) {
  return typeof value === 'number' ? "".concat(value / 10, "rem") : value;
}
export function getEm(value, parentFontSize) {
  if (typeof value !== 'number') return;
  return "".concat(value / parentFontSize, "em");
}
//# sourceMappingURL=getRem.js.map